import React from 'react';
import { Button, Modal } from 'semantic-ui-react';
import Info from '../Info';
import './carrierReview.scss';
import '../styles.scss';

const PREVIEW_LENGTH = 200;
const MODAL_TITLE = 'Ваш отзыв о работе ТК по данной посылке';
const MODAL_TOOLTIP =
    'Ваш отзыв о работе ТК по данной посылке. Оставить или отредактировать его можно, зайдя в посылку или на странице "Мои отправления". Для этого нажмите на звездочки оценки под логотипом транспортной компании.';

export default class CarrierReviewCommentCell extends React.Component {
    constructor(args) {
        super(args);
        this.state = {
            modalOpen: false
        };
    }

    openModal = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({ modalOpen: true });
    };

    closeModal = () => {
        this.setState({ modalOpen: false });
    };

    render() {
        const text = this.props.text || '';
        if (!text) {
            return null;
        }

        const needsExpand = text.length > PREVIEW_LENGTH;
        const preview = needsExpand ? text.slice(0, PREVIEW_LENGTH) : text;

        return (
            <div className="carrier-review-comment-cell">
                <div className="carrier-review-comment-cell__text">{preview}</div>
                {needsExpand && (
                    <button
                        type="button"
                        className="carrier-review-comment-cell__expand"
                        onClick={this.openModal}
                    >
                        Показать полностью…
                    </button>
                )}
                <Modal
                    className="modal-confirm carrier-review-comment-modal"
                    open={this.state.modalOpen}
                    onClose={this.closeModal}
                    size="small"
                    closeIcon
                >
                    <Modal.Header>
                        <span className="carrier-review-comment-modal__title">
                            {MODAL_TITLE}
                            <Info text={MODAL_TOOLTIP} className="carrier-review-comment-modal__tooltip" />
                        </span>
                    </Modal.Header>
                    <Modal.Content className="modal__content">
                        <div className="carrier-review-comment-modal__text">{text}</div>
                    </Modal.Content>
                    <Modal.Actions className="modal__actions">
                        <Button className="modal__actions_yes" onClick={this.closeModal}>
                            Закрыть
                        </Button>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./App/components/CarrierReview/CarrierReviewCommentCell.jsx